module.exports = __webpack_public_path__ + "img/SKS_Logo_Negativ_RGB.c67aa23c.png";